export default {
  id: null,
  companyID: null,
  areaID: null,
  name: null,
  mnemonic: null,
  color: null,
  description: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/stagemodel.js